import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { ProfileService } from '../../profile.service';
import { ApiService } from '../../api.service';
import { MatDialog } from '@angular/material/dialog';
import { DialogOverviewConfirmationComponent } from '../../dialog-overview-confirmation/dialog-overview-confirmation.component';

@Component({
  selector: 'lib-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss']
})
export class SettingsComponent implements OnInit, OnDestroy {
  currentUserData: any;
  emailNotification: any;
  settingsForm: FormGroup;
  consentForm: FormGroup;
  smsNotification: any;
  currentLang: string = '';
  canEdit: boolean = true;
  optionsLang: any = [];
  selectedLang: any;
  @Input() userprinciplename;
  @Input() clientId;
  @Input() clientSecret;
  @Input() enableSetting;
  @Input() isAudit;
  @Input() isPromotional;
  @Input() isConsent;
  isNotHartmannUser: boolean = true;
  @Input() passAppList;
  userTypeSubscription: Subscription;
  @Output() dataEvent = new EventEmitter();
  public optionsApp = [
    { appId: "1", appName: "--Select--" }
  ];

  constructor(
    public translate: TranslateService,
    private profileService: ProfileService,
    private formbuilder: FormBuilder,
    private apiService: ApiService,
    public dialog: MatDialog) { }

  ngOnInit() {
    const initailLanguage = JSON.parse(localStorage.getItem('userObject'));
    const currentCountry = localStorage.getItem('countryVal');
    this.canEdit = initailLanguage.country.toLowerCase() == currentCountry.toLowerCase();
    this.settingsForm = this.formbuilder.group({
      preferredLanguage: [''],
      defaultAppId: [''],
      isPromotionalMessage: ['']
    });
    if (this.passAppList) {
      this.settingsForm.patchValue({
        isPromotionalMessage: this.passAppList.isPromotionalMessage,
        preferredLanguage: initailLanguage.preferredLanguage,
        defaultAppId: this.passAppList.defaultAppId
      })
      var profileList = this.passAppList.profileAppList.filter(res => res.appCountry == localStorage.getItem('countryVal'));
      this.optionsApp.push(...profileList)
    }
  }

  ngOnChanges() {
    if (!!JSON.parse(localStorage.getItem('langObject'))) {
      this.optionsLang = JSON.parse(localStorage.getItem('langObject'));
    }
    this.userTypeSubscription = this.profileService.userTypeValue$.subscribe(data => {
      if (data == 'Hartmann' || data == 'Developer') {
        this.isNotHartmannUser = false;
      }
    },
      error => {
        console.log("Error: ", error);
      })

  }
  updateConsent(id, event) {
    if (id == 1)
      this.passAppList.isPromotionalMessage = event.checked;
    if (id == 3)
      this.settingsForm.value.userId = this.userprinciplename;
    this.apiService.updateUserProfileConsentData(this.settingsForm.value).subscribe(
      (data) => {
        if (data !== null && data !== undefined) {
        }

      },
      (error) => {
        console.log("Error: ", error);
      }
    )
  }
  resetPassword() {
    if (!this.isNotHartmannUser) {
      window.open("https://pwm.app.hartmann.info/PMUser/", "_blank");
    } else {
      const dialogRef = this.dialog.open(DialogOverviewConfirmationComponent, {
        width: '500px',
        disableClose: true
      });
      dialogRef.componentInstance.confirmData = "Are you sure do you want to reset password.";
      dialogRef.afterClosed().subscribe(result => {
        if (result.event === 'confirm') {
          this.confirmresetPassword();
        }
      },
        error => {
          console.log("Error: ", error);
        });
    }
  }
  confirmresetPassword() {
    var data = {
      userPrincipleName: this.userprinciplename,
    }
    this.apiService.initiatePasswordReset(data).subscribe(res => {
      if (res) {
        this.dataEvent.emit({ event: 'success' })
      } else {
        this.dataEvent.emit({ event: 'failure' })
      }
    },
      error => {
        console.log("Error: ", error);
      })
  }
  ngOnDestroy() {
    if (this.userTypeSubscription)
      this.userTypeSubscription.unsubscribe();
  }

  updateLanguage(event) {
    this.apiService.updateUserPreferredLanguage(event.value).subscribe(data => {
      if (data) {
        const profileData = JSON.parse(localStorage.getItem('userObject'));
        profileData.preferredLanguage = event.value;
        localStorage.setItem('userObject', JSON.stringify(profileData));
        this.dataEvent.emit({ event: 'langChange', data: event.value })
      }
    },
      error => {
        console.log("Error: ", error);
      })
  }
  updateSetting(event) {
    this.smsNotification = event.checked;
    this.settingsForm.value.userId = this.userprinciplename;
    this.apiService.updateUserPrivateSettingData(this.settingsForm.value).subscribe(
      (data) => {
        if (data !== null && data !== undefined) {
          const userData = JSON.parse(localStorage.getItem('userObject'));
          userData.defaultAppId = data.defaultAppId;
          userData.defaultAppUrl = data.defaultAppUrl;
          localStorage.setItem('userObject', JSON.stringify(userData));
        }
      },
      error => {
        console.log("Error: ", error);
      }
    )
  }
}